import * as React from 'react'
import { Container } from '../Container'

type Props = {
  title?: string
}

export const FastAndReliableSection: React.FC<Props> = ({ title }) => {
  return (
    <section className="text-center pt-0">
      <Container>
        <h2 className='title'>{title || 'FAST AND RELIABLE BRAKE REPAIR'}</h2>
        <p className="description text-xl">
          Experience fast and reliable brake repair you can trust, confidently backed by over{' '}
          <b>15,000 five-star Google Reviews</b> from satisfied customers. At Nubrakes, we understand that your brakes
          are your car&apos;s most important safety feature. That&apos;s why we take care of them like they&apos;re our own. Our
          skilled technicians use only high-quality parts and equipment to ensure you get the best brake repair
          possible.
        </p>
      </Container>
    </section>
  )
}
